<template>
  <div>
    <RadialProgressBar
      v-if="hasData"
      v-b-tooltip.hover
      :title="tooltipTitle"
      :inputData="parseFloat(this.diskUsage)"
      label="Disk"
    ></RadialProgressBar>
    <div v-else-if="loaded">
      {{ $t("No Data Available") }}
    </div>
    <SpinnerCmpt v-else></SpinnerCmpt>
  </div>
</template>

<script>
import RadialProgressBar from '@/xvisor/components/agents/RadialProgressBar.vue';
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';
import diskUsageText from '@/xvisor/utilities/diskUsageText';

export default {
  components: {
    RadialProgressBar,
    SpinnerCmpt,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      disk: undefined,
    };
  },
  mounted() {
    this.httpGet();
  },
  computed: {
    tooltipTitle() {
      return `${diskUsageText.bytesText(this.disk)} (${diskUsageText.percentText(this.disk)})`;
    },
    diskUsage() {
      return ((this.disk.usedBytes / this.disk.totalBytes) * 100).toFixed(1);
    },
    hasData() {
      return this.loaded && this.disk;
    },
  },
  methods: {
    httpGet() {
      this.$http
        .get(this.url)
        .then((response) => { this.disk = response.data; })
        .finally(() => { this.loaded = true; });
    },
  },
};
</script>
